import { render, staticRenderFns } from "./Embed.vue?vue&type=template&id=251fac22&"
import script from "./Embed.vue?vue&type=script&lang=ts&"
export * from "./Embed.vue?vue&type=script&lang=ts&"
import style0 from "./Embed.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports